import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Modal from "@mui/material/Modal";
import { styled } from "@mui/material/styles";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "60%",
  height: "fit-content",
  bgcolor: "rgba(47,26,111,0.91)",
  boxShadow: 24,
  p: 4,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  flexDirection: "column",
  color: "#FFF",
  textAlign: "center",
  borderRadius: "12px",
  maxHeight: "90vh",
};

const ModalWrapper = styled("div")``;

export default function BasicModal({ open, handleClose, children }) {
  return (
    <ModalWrapper>
      <Modal
        open={open}
        onClose={handleClose}
        hideBackdrop={false}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style} className="modalStyle">
          {children}
        </Box>
      </Modal>
    </ModalWrapper>
  );
}
